<template>
  <div class="flex items-center border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden w-full">
    <button
      v-for="opt in options"
      :key="opt.value"
      @click="emit('update:modelValue', opt.value)"
      class="flex-1 py-2 text-sm font-medium transition-colors"
      :class="modelValue === opt.value
        ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400'
        : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800'"
    >
      {{ opt.label }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, required: true },
})
const emit = defineEmits(['update:modelValue'])

const options = [
  { value: 'internal', label: 'Weekler Booking' },
  { value: 'external', label: 'Calendar Event' },
]
</script>
